import { parseISO, subHours, format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import { formatCentsToDollars } from '@/lib/utilities'
import { CancellationTriggerReason } from '@/types/interfaces/visit'

const FEE_ELIGIBLE_VISIT_TYPES = ['video_visit', 'video_visit_with_specialist_consultation'] as const

export function isFeeEligibleVisitType(visitType: string): boolean {
    return (FEE_ELIGIBLE_VISIT_TYPES as readonly string[]).includes(visitType)
}

export function shouldShowFeePolicy(
    visit: { visit_type: string; cancellation_fee_policy_applies?: boolean },
): boolean {
    return visit.cancellation_fee_policy_applies === true && isFeeEligibleVisitType(visit.visit_type)
}

export function isWithin24Hours(scheduledTime: string | null | undefined): boolean {
    if (!scheduledTime) return false
    const msUntil = new Date(scheduledTime).getTime() - Date.now()
    return msUntil < 24 * 60 * 60 * 1000
}

export function formatFeeAmount(amountCents: number | null | undefined): string {
    if (amountCents == null) return formatCentsToDollars(2500)
    return formatCentsToDollars(amountCents)
}

export function formatFreeCancellationDeadline(scheduledTime: string): string {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const dateTimeObj = parseISO(scheduledTime)
    const deadline = subHours(dateTimeObj, 24)
    const zonedDeadline = utcToZonedTime(deadline, timeZone)
    const time = format(zonedDeadline, 'h:mma').toLowerCase()
    const date = format(zonedDeadline, 'MMM d')
    return `${date} at ${time}`
}

export function isNoShowCancellation(cancellationReason: string | null | undefined): boolean {
    return cancellationReason === 'no_show'
}

const TRIGGER_LABELS: Record<CancellationTriggerReason, string> = {
    late_customer_cancel: 'Same-day cancellation fee',
    no_show: 'No-show fee',
    no_show_predicted: 'Same-day cancellation fee',
    no_confirmation: 'Same-day cancellation fee',
    no_id_verification: 'Same-day cancellation fee',
    missing_insurance: 'Same-day cancellation fee',
}

export function getFeeTriggerLabel(triggerReason: CancellationTriggerReason): string {
    return TRIGGER_LABELS[triggerReason] ?? 'Cancellation fee'
}
